import React, { useState } from 'react';
import '../../styles/dashboardPagesStyle/Charts.css';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  LabelList,
  Cell,
} from 'recharts';
import { Info } from 'lucide-react';

interface IntervaloDataItem {
  intervalo: string;
  quantidade: number;
}

interface BarLateralIntervalosProps {
  titulo: string;
  dados: IntervaloDataItem[];
  infoText: string;
}

const corAzul = '#29306A';

export default function BarLateralIntervalos({
  titulo,
  dados,
  infoText,
}: BarLateralIntervalosProps) {
  const [popup, setPopup] = useState<{ visible: boolean; text: string }>({
    visible: false,
    text: '',
  });

  const handleInfoClick = () => setPopup({ visible: true, text: infoText });
  const fecharPopup = () => setPopup({ visible: false, text: '' });

  // calcula o total
  const total = dados.reduce((acc, item) => acc + item.quantidade, 0);

  return (
    <div className="card-grafico-produto info-card">
      <h3>{titulo}</h3>
      <Info className="info-btn" size={20} onClick={handleInfoClick} />

      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          layout="vertical"
          data={dados}
          margin={{ top: 20, right: 40, left: 40, bottom: 20 }}
        >
          <XAxis type="number" /> {/* Quantidade no eixo X */}
          <YAxis dataKey="intervalo" type="category" width={80} />
          <Tooltip
            formatter={(value: any) =>
              typeof value === 'number' && total > 0
                ? `${value} (${((value / total) * 100).toFixed(1)}%)`
                : String(value ?? '')
            }
            labelFormatter={(label) => String(label)}
          />
          <Bar dataKey="quantidade" name="Quantidade" fill={corAzul}>
            {dados.map((entry, index) => (
              <Cell key={index} fill={corAzul} />
            ))}
            {/* Mostra só a quantidade, sem porcentagem */}
            <LabelList
              dataKey="quantidade"
              position="right"
              style={{ fontSize: 10, fill: '#29306A', fontWeight: 'bold' }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>


      {popup.visible && (
        <div className="info-popup-overlay" onClick={fecharPopup}>
          <div className="info-popup" onClick={(e) => e.stopPropagation()}>
            <h4>Informações</h4>
            <p>{popup.text}</p>
            <button onClick={fecharPopup}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
}
